import React from 'react'
import Topbar from '../Mainhometwo/Topbar'
import Header2 from '../../Globle/Header2'
import Hometwosilder from '../Mainhometwo/Hometwosilder'
import Services from '../Mainhometwo/Services'
import Prodect from '../Mainhometwo/Prodect'
import Modren from '../Mainhometwo/Modren'
import Tranding from '../Mainhometwo/Tranding'
import BestSeller from '../Mainhometwo/BestSeller'
import Deals from '../Mainhometwo/Deals'
import NewCollection from '../Mainhometwo/NewCollection'
import Blog from '../Mainhometwo/Blog'
import ProdectSlider from '../Mainhometwo/ProdectSlider'
import Footer2 from '../../Globle/Footer2'


const Main = () => {
    return (
        <>
            <Topbar />
            <Header2 />
            <Hometwosilder />
            <Services />
            <Prodect />
            <Modren />
            <Tranding />
            <BestSeller />
            <Deals />
            <NewCollection />
            <Blog />
            <ProdectSlider />
            <Footer2 />
        </>
    )
}

export default Main
